export const InvoiceDemoData = {
    billingAddress: {
        id: 6,
        userId: 1,
        addressType: 'billing',
        firstName: 'Bipon',
        lastName: 'Biswas',
        organization: 'Miracle Advance',
        address: 'Boyra',
        phone: '8801920835077',
        email: 'bipon@gmail.com',
        country: 'BD',
        state: 'Khulna Division',
        city: 'Khulna',
        zip: '9202',
        status: 'active',
        demo: true
    },
    invoice: {
        id: 32,
        firstName: 'Yeasin',
        lastName: 'Arafat',
        email: '',
        phone: '',
        invoiceTitle: 'Purchase',
        note: '',
        status: 'pending',
        timeIssue: 1701368872,
        timeDue: 1701455272,
        timeCanceled: 0,
        timeCreated: 1701368872,
        timeUpdated: 1701368872,
        demo: true
    },
    invoiceItems: [
        {
            id: 154,
            price: 100,
            priceOffer: 100,
            quantity: 1,
            unitName: 'ppu',
            domain: 'yeasin.net',
            subscriptionId: 0,
            subscriptionStart: 1703999431,
            subscriptionEnd: 0,
            productTitle: '---------------------',
            productDescription: '----------------------------------------',
            status: 'active',
            timeCreated: 1703999431,
            timeUpdated: 1703999431,
            logoUrl:
                'https://storage.googleapis.com/miracle-bucket-23/application_logo/envision.png',
            packageName: 'Ultra',
            limitBy: 'ppu',
            limitByValue: 120,
            demo: true
        }
    ],
    demo: true
};

export default null;
